export default __webpack_public_path__ + "static/media/image-document.8289704b.svg";